module.exports = __webpack_public_path__ + "881731f8ce0502086f4dbc1d3d102b61.svg";